import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, Output } from "@angular/core";
import { Address } from "@spartacus/core";
import { ICON_TYPE } from "@spartacus/storefront";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Subscription } from "rxjs";
import { filter, switchMap, take, tap } from "rxjs/operators";
import { GenCheckoutService } from "src/app/generac/services/checkout.service";
import { GenLaunchDialogService } from "src/app/generac/services/launch-dialog.service";

@Component({
  selector: 'gen-saved-address-item',
  templateUrl: './saved-address-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GenSavedAddressItemComponent implements OnDestroy {
  @Input() savedAddress: Address;
  @Input() isUserRestricted: boolean;
  @Output() savedAddressDeleted = new EventEmitter();
  iconTypes = ICON_TYPE;

  private subscription = new Subscription();

  constructor(
    protected checkoutService: GenCheckoutService,
    protected launchDialogService: GenLaunchDialogService,
    protected cd: ChangeDetectorRef,
    private userAccount: UserAccountFacade,
  ) { }

  public openEditSavedAddressModal(savedAddress: Address): void {
    if (this.isUserRestricted) return;

    this.launchDialogService.openDialogAndSubscribe(
      'EDIT_SAVED_ADDRESS',
      undefined,
      { savedAddress }
    );

    this.subscription.add(
      this.launchDialogService.dialogClose
        .pipe(
          filter((data) => !!data?.companyName),
          take(1),
          switchMap(() => this.userAccount.get()),
          switchMap((user) => this.checkoutService.getDropShipAddressById(user.uid, this.savedAddress?.id)),
          tap((savedAddress: Address) => this.savedAddress = savedAddress),
          tap(() => this.cd.markForCheck())
        )
        .subscribe()
    );
  }

  public openDeleteSavedAddressModal(id: string) {
    if (this.isUserRestricted) return;

    const dialog = this.launchDialogService.openDialog(
      'DELETE_SAVED_ADDRESS',
      undefined,
      undefined,
      { id }
    );

    if (dialog) {
      dialog.pipe(take(1)).subscribe();
    }

    this.subscription.add(
      this.launchDialogService.dialogClose
        .pipe(
          filter((id) => id == this.savedAddress?.id),
          take(1),
          tap((id) => this.savedAddressDeleted.emit(id)),
        )
        .subscribe()
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}